import { render, staticRenderFns } from "./ZonaDetalheModal.vue?vue&type=template&id=648a919f&scoped=true&"
import script from "./ZonaDetalheModal.vue?vue&type=script&lang=js&"
export * from "./ZonaDetalheModal.vue?vue&type=script&lang=js&"
import style0 from "./ZonaDetalheModal.vue?vue&type=style&index=0&id=648a919f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a919f",
  null
  
)

export default component.exports